import React from 'react';
import styled from 'styled-components';
import { theme } from '@theme';
import { FiTrendingUp } from 'react-icons/fi';

interface ScoreDisplayProps {
  score: number;
  variant?: 'card' | 'inline' | 'compact';
  showLabel?: boolean;
}

const ScoreCard = styled.div`
  background: ${theme.colors.primary};
  border-radius: ${theme.borderRadius.lg};
  padding: ${theme.spacing.xl};
  text-align: center;
  color: ${theme.colors.white};
`;

const ScoreLabel = styled.div`
  font-size: ${theme.typography.sizes.base};
  margin-bottom: ${theme.spacing.md};
  opacity: 0.9;
`;

const ScoreValue = styled.div`
  font-size: ${theme.typography.sizes['4xl']};
  font-weight: ${theme.typography.weights.bold};
  margin-bottom: ${theme.spacing.sm};
`;

const ScoreMaximum = styled.div`
  font-size: ${theme.typography.sizes.lg};
  opacity: 0.8;
`;

const InlineScore = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.md};
`;

const InlineLabel = styled.span`
  font-size: ${theme.typography.sizes.sm};
  color: ${theme.colors.text}80;
`;

const InlineValue = styled.span<{ $score: number }>`
  font-size: ${theme.typography.sizes.xl};
  font-weight: ${theme.typography.weights.bold};
  color: ${props =>
    props.$score >= 70
      ? theme.colors.success
      : props.$score >= 50
      ? theme.colors.warning
      : theme.colors.error};
`;

const CompactScore = styled.div<{ $score: number }>`
  display: inline-flex;
  align-items: center;
  gap: ${theme.spacing.xs};
  padding: ${theme.spacing.xs} ${theme.spacing.sm};
  border-radius: ${theme.borderRadius.md};
  background: ${props =>
    props.$score >= 70
      ? theme.colors.success + '20'
      : props.$score >= 50
      ? theme.colors.warning + '20'
      : theme.colors.error + '20'};
  color: ${props =>
    props.$score >= 70
      ? theme.colors.success
      : props.$score >= 50
      ? theme.colors.warning
      : theme.colors.error};
  font-size: ${theme.typography.sizes.sm};
  font-weight: ${theme.typography.weights.semibold};

  svg {
    font-size: 16px;
  }
`;

export const ScoreDisplay: React.FC<ScoreDisplayProps> = ({
  score,
  variant = 'card',
  showLabel = true,
}) => {
  if (variant === 'card') {
    return (
      <ScoreCard>
        {showLabel && <ScoreLabel>Score de candidature</ScoreLabel>}
        <ScoreValue>{score}</ScoreValue>
        <ScoreMaximum>/ 100</ScoreMaximum>
      </ScoreCard>
    );
  }

  if (variant === 'inline') {
    return (
      <InlineScore>
        {showLabel && <InlineLabel>Score obtenu:</InlineLabel>}
        <InlineValue $score={score}>{score}/100</InlineValue>
      </InlineScore>
    );
  }

  // compact variant
  return (
    <CompactScore $score={score}>
      <FiTrendingUp />
      {score}/100
    </CompactScore>
  );
};
